module.exports = __webpack_public_path__ + "media/ni_zen_me_yang.462ed97c.mp3";